// extracted by mini-css-extract-plugin
export default {"wrapper":"nav-items-module--wrapper--2291a","item":"nav-items-module--item--e53df"};